import { Component } from '@angular/core';

@Component({
  selector: 'app-landing-pricing',
  templateUrl: './landing-pricing.component.html',
  styleUrls: ['./landing-pricing.component.css']
})
export class LandingPricingComponent {

}
